// extracted by mini-css-extract-plugin
module.exports = {"receipt-version-container":"OriginalReceiptVersion_receipt-version-container__1SG1Y"};